import React from 'react';
import { useParams, Link } from 'react-router-dom';

const ServiceDetail = () => {
  const { serviceName } = useParams();
  
  // Convert URL parameter to readable format
  const formatServiceName = (name) => {
    return name
      .split('-')
      .map(word => word.charAt(0).toUpperCase() + word.slice(1))
      .join(' ');
  };

  const serviceNameFormatted = formatServiceName(serviceName);

  const serviceDetails = {
    'all': {
      title: 'All Services',
      description: 'Our comprehensive suite of property management services designed to handle every aspect of your property needs.',
      features: [
        'Complete property management',
        'Tenant screening and placement',
        'Maintenance coordination',
        'Financial reporting',
        '24/7 support'
      ]
    },
    'hassle-free-move-ins': {
      title: 'Hassle-Free Move-Ins',
      description: 'Streamlined move-in process that makes transitioning to your new property seamless and stress-free.',
      features: [
        'Pre-move-in inspections',
        'Key handover coordination',
        'Welcome packages for tenants',
        'Orientation and documentation',
        'Quick issue resolution'
      ]
    },
    'flatmate-matching': {
      title: 'Flatmate Matching',
      description: 'Find the perfect roommate match using our advanced screening and compatibility system.',
      features: [
        'Comprehensive background checks',
        'Lifestyle compatibility matching',
        'Personality assessments',
        'Secure platform for connections',
        'Ongoing support and mediation'
      ]
    },
    'maintenance-resolution': {
      title: 'Maintenance Resolution',
      description: 'Fast and efficient maintenance services with a network of trusted professionals.',
      features: [
        '24/7 emergency response',
        'Pre-screened contractors',
        'Quick turnaround times',
        'Quality guarantee',
        'Transparent pricing'
      ]
    },
    'amenities-package': {
      title: 'Amenities Package',
      description: 'Enhance your property value with our comprehensive amenities management and offerings.',
      features: [
        'Fitness facilities management',
        'Common area maintenance',
        'Package receiving services',
        'Community event coordination',
        'Premium amenities access'
      ]
    },
    'flexible-leasing-options': {
      title: 'Flexible Leasing Options',
      description: 'Flexible lease terms that work for both property owners and tenants.',
      features: [
        'Short-term and long-term leases',
        'Month-to-month options',
        'Customizable lease terms',
        'Easy renewal process',
        'Transparent fee structure'
      ]
    },
    'vetted-properties': {
      title: 'Vetted Properties',
      description: 'All properties in our network undergo rigorous screening to ensure quality and safety.',
      features: [
        'Property inspections',
        'Safety compliance checks',
        'Quality standards verification',
        'Regular maintenance reviews',
        'Owner verification process'
      ]
    },
    'neighborhood-guidance': {
      title: 'Neighborhood Guidance',
      description: 'Comprehensive information about neighborhoods to help you make informed decisions.',
      features: [
        'Local market insights',
        'School district information',
        'Transportation guides',
        'Safety statistics',
        'Community resources'
      ]
    },
    'paperwork-assistance': {
      title: 'Paperwork Assistance',
      description: 'We handle all the documentation so you don\'t have to worry about the paperwork.',
      features: [
        'Lease preparation',
        'Document verification',
        'Compliance documentation',
        'Renewal paperwork',
        'Legal document assistance'
      ]
    },
    '24-7-support': {
      title: '24/7 Support',
      description: 'Round-the-clock assistance whenever you need it, ensuring peace of mind.',
      features: [
        'Emergency hotline',
        'Online chat support',
        'Email support',
        'Mobile app access',
        'Dedicated support team'
      ]
    },
    'community-events': {
      title: 'Community Events',
      description: 'Build a sense of community with our organized events and activities.',
      features: [
        'Regular social gatherings',
        'Seasonal celebrations',
        'Networking events',
        'Workshop sessions',
        'Community service projects'
      ]
    }
  };

  const service = serviceDetails[serviceName.toLowerCase()] || {
    title: serviceNameFormatted,
    description: `Learn more about our ${serviceNameFormatted} service.`,
    features: []
  };

  return (
    <section className="bg-white py-16 md:py-24 px-4 md:px-8">
      <div className="max-w-4xl mx-auto">
        <div className="mb-8">
          <span className="inline-block px-4 py-2 bg-furniflex-teal/10 text-furniflex-teal rounded-full text-sm font-semibold uppercase tracking-wide mb-4">
            SERVICE
          </span>
          <h1 className="text-4xl md:text-5xl lg:text-6xl font-extrabold text-gray-900 mb-6 leading-tight">
            {service.title}
          </h1>
          <div className="w-20 h-1 bg-furniflex-teal mb-8"></div>
        </div>

        <div className="prose prose-lg max-w-none mb-12">
          <p className="text-xl text-gray-700 leading-relaxed mb-8">
            {service.description}
          </p>
        </div>

        <div className="bg-gray-900 rounded-2xl p-8 md:p-12 text-white text-center">
          <h3 className="text-2xl md:text-3xl font-bold mb-4">
            Interested in This Service?
          </h3>
          <p className="text-lg text-gray-300 mb-6">
            Contact us to learn more or get started today.
          </p>
          <Link 
            to="/contact"
            className="inline-block px-8 py-4 bg-furniflex-teal text-white rounded-lg font-semibold text-lg hover:bg-teal-600 transition-colors shadow-lg"
          >
            Get in Touch
          </Link>
        </div>
      </div>
    </section>
  );
};

export default ServiceDetail;

